<div class="tree-node" [ngClass]="{ 'ms-4': level > 0 }">
  <div class="d-flex align-items-baseline">
    @if (hasChildren) {
      <button
        type="button"
        class="toggle-button btn btn-flat d-flex px-1 py-1 me-1"
        [attr.aria-label]="(node.collapsed ? 'expand' : 'collapse') | translate"
        (click)="onToggle()"
      >
        <svg aria-hidden="true" class="toggle-icon">
          @switch (isCollapsed) {
            @case (true) {
              <use xlink:href="#chevron-right-thin"></use>
            }
            @case (false) {
              <use xlink:href="#chevron-bottom-thin"></use>
            }
          }
        </svg>
      </button>
    } @else {
      <div class="px-1 py-1 me-1 placeholder-checkbox" aria-hidden="true"></div>
    }

    <app-common-checkbox [(ngModel)]="checked" [disabled]="node.disabled" [indeterminate]="isIndeterminate">
      @switch (node.translate) {
        @case (true) {
          <span class="checkbox-label">{{ node.text | translate }}</span>
        }
        @default {
          <span class="checkbox-label">{{ node.text }}</span>
        }
      }
    </app-common-checkbox>
  </div>

  @if (!isCollapsed && hasChildren) {
    <div role="group">
      @for (child of node.children; track $index; let index = $index) {
        <app-checkbox-tree-node
          [level]="level + 1"
          [index]="index"
          [treeId]="treeId"
          [config]="config"
          [node]="child"
          (nodeChanged)="onChildNodeChanged(child, $event)"
        >
        </app-checkbox-tree-node>
      }
    </div>
  }
</div>
